import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleRegisterVehicleCategory from "./vehicleRegisterVehicleCategory";
import VehicleRegisterVehicleClassifiedFuelType from "./vehicleRegisterVehicleClassifiedFuelType";
import type VehicleRegisterVehicleFuelType from "./vehicleRegisterVehicleFuelType";
import VehicleRegisterVehicleStatus from "./vehicleRegisterVehicleStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SingleChargeVehicleRegisterVehicleDetailResponse {
  @observable
  externalVehicleIdent!: number;

  @observable
  licensePlate!: string;

  @observable
  @Type(() => Date)
  updatedAt!: Date;

  @observable
  vin?: string;

  @observable
  @Type(() => Date)
  licensePlateValidSinceDate?: Date;

  @observable
  @Type(() => Date)
  licensePlateValidUntilDate?: Date;

  @observable
  vehicleStatus?: VehicleRegisterVehicleStatus;

  @observable
  @Type(() => Date)
  vehicleStatusValidSinceDate?: Date;

  @observable
  @Type(() => Date)
  vehicleStatusValidUntilDate?: Date;

  @observable
  category?: VehicleRegisterVehicleCategory;

  @observable
  categoryName?: string;

  @observable
  maximumAllowedWeight?: number;

  @observable
  emissionsCo2?: number;

  @observable
  fuelTypes?: VehicleRegisterVehicleFuelType[];

  @observable
  fuelTypeName1?: string;

  @observable
  fuelTypeName2?: string;

  @observable
  fuelTypeName3?: string;

  @observable
  classifiedFuelType!: VehicleRegisterVehicleClassifiedFuelType;
}
